import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
const getSettingsBaseUrl = section => `${getFullUrl('app')}/${section}`;
export const getPortalSettingsRootUrl = () => `${getSettingsBaseUrl('settings')}/${PortalIdParser.get()}`;
export const getSettingsRootUrl = () => `${getSettingsBaseUrl('live-messages-settings')}/${PortalIdParser.get()}`;